<template>
  <a-modal
    :visible="show"
    title="选择门店"
    @ok="handleStoreSelected"
    @cancel="handleStoreCancel"
    :width="1000"
  >
    <a-table
      :row-selection="rowSelection"
      :data-source="storeAll"
      :columns="columnsModal"
      :pagination="{pageSize: 5}"
      row-key="id"
    >
      <div
        slot="filterDropdown"
        slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
        style="padding: 8px"
      >
        <a-input
          ref="searchInput"
          placeholder="搜索门店名称"
          :value="selectedKeys[0]"
          style="width: 188px; margin-bottom: 8px; display: block;"
          @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
          @pressEnter="() => modalTableSearch(selectedKeys, confirm, column.dataIndex)"
        />
        <a-button
          type="primary"
          icon="search"
          size="small"
          style="width: 90px; margin-right: 8px"
          @click="() => modalTableSearch(selectedKeys, confirm, column.dataIndex)"
        >
          搜索
        </a-button>
        <a-button
          size="small"
          style="width: 90px"
          @click="() => modalTableReset(clearFilters)"
        >
          重置
        </a-button>
      </div>
      <a-icon
        slot="filterIcon"
        slot-scope="filtered"
        type="search"
        :style="{ color: filtered ? '#108ee9' : undefined }"
      />
    </a-table>
    <div class="store__group__modal__row">
      <span>已选门店(共{{ selectorMarket.length }}家)：</span>
      <span
        class="store__group__modal__span"
        v-for="item in selectorMarket"
        :key="item.id"
      >
        <a-tag>{{ item.storeName }}</a-tag>
      </span>
    </div>
  </a-modal>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      // modal表格search
      searchText: '',
      searchedColumn: '',
      columnsModal: [
        {
          title: '门店号',
          dataIndex: 'storeCode',
        },
        {
          title: '门店名称',
          dataIndex: 'storeName',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'customRender',
          },
          onFilter: (value, record) => record.storeName
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.$refs.searchInput.focus();
              }, 100);
            }
          },
        },
        {
          title: '省市',
          dataIndex: 'provCity',
          customRender: (text, record) => `${record.provinceName}-${record.cityName}`,
          filters: window._.uniqBy(
            this.$forceUpdatestoreAll,
            record => `${record.provinceName}-${record.cityName}`,
          ).map(i => ({
            text: `${i.provinceName}-${i.cityName}`,
            value: `${i.provinceName}-${i.cityName}`,
          })),
          onFilter: (value, record) => `${record.provinceName}-${record.cityName}`.includes(value),
        },
        {
          title: '业态',
          dataIndex: 'formatName',
          filters: window._.uniqBy(this.storeAll, record => record.formatName).map(i => ({
            text: i.formatName,
            value: i.formatName,
          })),
          customRender: text => text || '--',
          onFilter: (value, record) => record.formatName && record.formatName.indexOf(value) === 0,
        },
        {
          title: '流量等级',
          dataIndex: 'flowLevel',
          onFilter: (value, record) => record.flowLevel && record.flowLevel.indexOf(value) === 0,
          filters: [
            { text: '高', value: 'high' },
            { text: '中', value: 'mid' },
            { text: '低', value: 'low' },
          ],
          customRender: (text) => {
            const mapState = {
              high: '高',
              mid: '中',
              low: '低',
            };
            return mapState[text] || '--';
          },
        },
        {
          title: '状态',
          dataIndex: 'checkResult',
          onFilter: (value, record) => record.checkResult && record.checkResult.indexOf(value) === 0,
          filters: [
            { text: '正常', value: 'ok' },
            { text: '异常', value: 'fluctation' },
          ],
          scopedSlots: { customRender: 'render_state' },
          customRender: (text) => {
            if (text === 'ok') {
              return '正常';
            }
            if (text === 'fluctation') {
              return '异常';
            }
            return '--';
          },
        },
      ],
      selectedRowKeys: [],
      selectorMarket: [],
    };
  },
  computed: {
    ...mapState('storeManage', ['storeAll', 'storeGroupName', 'storeIdList']),
    rowSelection() {
      const { selectedRowKeys } = this;
      return {
        selectedRowKeys,
        onChange: this.onTableSelectChange,
        hideDefaultSelections: true,
        columnWidth: 120,
        selections: [
          {
            key: 'all',
            text: '  选择全部',
            onSelect: () => {
              // eslint-disable-next-line vue/no-side-effects-in-computed-properties
              this.selectedRowKeys = this.storeAll.map(i => i.id);
            },
          },
          {
            key: 'clear',
            text: '清空全部',
            onSelect: () => {
              // eslint-disable-next-line vue/no-side-effects-in-computed-properties
              this.selectedRowKeys = [];
            },
          },
          {
            key: 'scavenge',
            text: '选择当页',
            onSelect: (changableRowKeys) => {
              // eslint-disable-next-line vue/no-side-effects-in-computed-properties
              this.selectedRowKeys = changableRowKeys;
            },
          },
        ],
      };
    },
  },
  watch: {
    storeIdList: {
      handler() {
        const { storeIdList } = this;
        if (storeIdList && storeIdList.length) {
          this.selectedRowKeys = storeIdList.map(item => String(item));
        } else {
          this.selectedRowKeys = [];
        }
      },
      immediate: true,
    },
    selectedRowKeys: {
      handler() {
        this.selectorMarket = this.storeAll.filter(i => this.selectedRowKeys.includes(String(i.id)));
      },
      immediate: true,
    },
  },
  methods: {
    modalTableSearch(selectedKeys, confirm, dataIndex) {
      confirm();
      [this.searchText] = selectedKeys;
      this.searchedColumn = dataIndex;
    },
    modalTableReset(clearFilters) {
      clearFilters();
      this.searchText = '';
    },
    onTableSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    handleStoreSelected() {
      this.$store.commit('storeManage/updateModalStoreIdList', this.selectedRowKeys);
      this.$emit('editShowchange', false);
    },
    handleStoreCancel() {
      this.$emit('editShowchange', false);
      this.selectedRowKeys = this.storeIdList.map(item => String(item));
    },
  },
};
</script>

<style>
.store__group__modal__row {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.store__group__modal__span {
  display: inline-block;
  margin-bottom: 8px;
}
</style>
